document.addEventListener("DOMContentLoaded", () => {

  // Select all form elements on the page
  var forms = document.querySelectorAll('form');
  // Iterate over each form
  forms.forEach(function(form) {
    form.addEventListener('submit', function(event) {
      // Prevent the default form submission behavior
      event.preventDefault();

      var formContainer = this.closest('form-container');
      // Get the ID of the form-container or a default value if not found
      var formContainerId = formContainer ? formContainer.id : '';
      
      window.dataLayer.push({
        'event': 'formSubmit',
        'formType': formContainerId
      });
    });
  }); 
  
  // Opti Forms Event
  if (typeof $$epiforms !== 'undefined') {
    $$epiforms(function () {
      $$epiforms('.EPiServerForms').on('formsSubmitted', function (event) {
        window.dataLayer.push({
          'event': 'formSubmit',
          'formType': 'optiForms'
        });
      });
    });
  }
  
  
  
});